if($("[data-section-type=header][data-type=v2]").length) {
  $(document).ready(init);
}
    
function init(){

    function deactivateLayer1() {
      $(".navigation__tier-1 > li").each((i, el) => {
        $(el).attr("data-active", "false");
        $(el).attr("data-toggled", "false");
      })
    }

    $(document).on("click", function(e) {
      if(!$(e.target).parents('[data-section-type=header]').length){
        deactivateLayer1();
      }
    });

    $(".navigation__tier-1 > li").on({
      click: function() {
        deactivateLayer1();
        $(this).attr("data-active", "true");
        $(this).attr("data-toggled", "true");
      }
    })

    $(".desktop-only .navigation__tier-1 li").on({
        mouseenter: function() {
            $(".navigation__tier-1 li").each((i, el) => {
              if ($(el).attr("data-active") == "true") {
                $(this).attr("data-level") == "1" && $(el).attr("data-active", false); // Hmm
              }
            });
            $(this).attr("data-level") == "1" && $(this).attr("data-active", true);
            $(this).attr("data-level") == "2" && $(this).attr("data-active", true);
            $(this).attr("data-level") == "2" && $(this).attr("data-toggled", true);
            $(this).attr("data-level") == "2" && $(this).attr("data-children") == "true" && $(this).parent().addClass("no-overflow"); 
        },
        mouseleave: function() {
          $(this).parent("ul").removeClass("no-overflow");
          $(this).attr("data-level") == "1" && $(this).attr("data-active", false); // Hmm
          $(this).attr("data-level") == "2" && $(this).attr("data-toggled", false); // Hmm
          $(this).attr("data-level") == "2" && $(this).attr("data-active", false); // Hmm
      }
    });

    $(".desktop-only .navigation__tier-1 li").on({
        click: function() {
          if ($(this).attr("data-children") == "true") {
            $(this).attr("data-level") == "2" && $(this).parent().toggleClass("no-overflow"); // Hmm
            $(this).attr("data-toggled", $(this).attr("data-toggled") == "true" ? "false" : "true");
            $(this).attr("data-active", true);
          }
        }
    });
}